import { render, staticRenderFns } from "./pcb_ban_layout.vue?vue&type=template&id=762e40a7&scoped=true"
import script from "./pcb_ban_layout.vue?vue&type=script&lang=js"
export * from "./pcb_ban_layout.vue?vue&type=script&lang=js"
import style0 from "./pcb_ban_layout.vue?vue&type=style&index=0&id=762e40a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762e40a7",
  null
  
)

export default component.exports